import React from 'react';


export default function LinkolnEmail(props) {
  let icon = ",";
  let color = "#B00";
  if (props.linkoln_email.status === "viewed") {
	  icon = "/";
    color = "#0B0";
  }
  const clipboard = () => {
    navigator.clipboard.writeText(props.linkoln_email.url);
  }
  let style = {
    "font-size": "12px"
  };

  const created_dt = new Date(props.linkoln_email.created);
  const created_str = new Intl.DateTimeFormat().format(created_dt);

  return (
    <tr className="align-middle">
      <td><font face="Wingdings" color={color} size="6">{ icon }</font></td>
      <td>{ props.linkoln_email.title }<br/><span style={ style }>posted on { created_str }</span></td>
      <td>{ props.linkoln_email.url } (<a target="_blank" rel="noreferrer" href={ props.linkoln_email.preview_url }>proof message</a>)</td>
        <td className="text-center"><span className="copy_link btn btn-danger btn-sm fw-normal text-white d-inline-block text-nowrap"  data-bs-toggle="modal" data-bs-target="#copyModal" onClick={clipboard}>Copy Link</span></td>
        <div className="modal fade" id="copyModal" tabindex="-1" aria-labelledby="copyModalLabel" aria-hidden="true">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h1 className="modal-title fs-5" id="copyModalLabel">Link Copied</h1>
                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>
              <div className="modal-body">
                Your link has been copied to your clipboard and is ready to paste.
              </div>
            </div>
          </div>
        </div>
    </tr>
  );
}
